export default __webpack_public_path__ + "static/media/link-learn-more-h.67c6ffe2.svg";